import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';
import { useNavigate } from 'react-router';
import routes from 'routes';

export const TurnaroundListButton = () => {
  const lang = useLanguage()[0].TurnaroundListButton;

  const navigate = useNavigate();

  return (
    <Button colors="active on white" onClick={() => navigate(routes.TurnaroundList.makePath())}>
      {lang.viewTurnaroundList}
    </Button>
  );
};
